import type { ComponentProps } from "react"
import { TabsList as TabsListBase } from "@/v2-ui/tabs/base/TabsBase"
import cn from "@/v2-ui/utils/utils.cn"

export type TabsListProps = ComponentProps<typeof TabsListBase>

function TabsList(props: TabsListProps) {
  const { className, ...tabsListBaseProps } = props
  return (
    <TabsListBase
      className={cn(
        "ui-tabs-list inline-flex items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground [&[data-orientation=vertical]]:flex-col [&[data-orientation=horizontal]]:flex-row",
        className,
      )}
      {...tabsListBaseProps}
    />
  )
}

export default TabsList
